document.addEventListener('DOMContentLoaded', () => {
    try {
        const artists = [
            {
                name: "Jihoon Kim 김지훈",
                backgroundImage:"https://cdn.shopify.com/s/files/1/0909/6963/7130/files/get_2.webp?v=1755676785",
                images: [
                    "https://source.unsplash.com/random/400x300?painting",
                    "https://source.unsplash.com/random/400x300?canvas",
                    "https://source.unsplash.com/random/400x300?studio"
                ]
            },
            {
                name: "Park Eunseo 박은서",
                backgroundImage:"https://cdn.shopify.com/s/files/1/0909/6963/7130/files/get_2.webp?v=1755676785",
                images: [
                   "https://source.unsplash.com/random/400x300?painting",
                    "https://source.unsplash.com/random/400x300?canvas",
                    "https://source.unsplash.com/random/400x300?studio"
                ]
            },
            {
                name: "Sunghee Shin 신성희",
                backgroundImage:"https://cdn.shopify.com/s/files/1/0909/6963/7130/files/get_2.webp?v=1755676785",
                images: [
                    "https://source.unsplash.com/random/400x300?painting",
                    "https://source.unsplash.com/random/400x300?canvas",
                    "https://source.unsplash.com/random/400x300?studio"
                ]
            },
            {
                name: "Minseo Park 민서 박",
                images: [
                    "https://source.unsplash.com/random/400x300?painting",
                    "https://source.unsplash.com/random/400x300?canvas",
                    "https://source.unsplash.com/random/400x300?studio"
                ]
            },
            {
                name: "Jihoon Kim 지훈 김",
                images: [
                    "https://source.unsplash.com/random/400x300?sculpture",
                    "https://source.unsplash.com/random/400x300?stone",
                    "https://source.unsplash.com/random/400x300?wood"
                ]
            },
            {
                name: "Hana Lee 하나 이",
                images: [
                    "https://source.unsplash.com/random/400x300?graphic",
                    "https://source.unsplash.com/random/400x300?colors",
                    "https://source.unsplash.com/random/400x300?abstract"
                ]
            },
            {
                name: "Taejin Choi 태진 최",
                images: [
                    "https://source.unsplash.com/random/400x300?photo",
                    "https://source.unsplash.com/random/400x300?portrait",
                    "https://source.unsplash.com/random/400x300?blackandwhite"
                ]
            }
        ];

        const section = document.getElementById('artistSection');
        const list = document.getElementById('artistToggle');
        const body = document.body;
        const header = document.querySelector('.custom-header');
        
        // This is a safety check: if the list doesn't exist, stop execution immediately.
        if (!section || !list) {
            console.error("artist.toggle.js: Critical HTML elements not found. Stopping script execution.");
            return;
        }


        function applyRandomThumbnailStyles(thumbnailsContainer) {
            // CRITICAL FIX: Manually enforce width/height on the container (thumbs)
            // to support absolute positioning of images without the full complex logic.
            thumbnailsContainer.style.width = '950px';
            thumbnailsContainer.style.height = '375px';
        }

        // --- 4. INITIAL CONTENT RENDERING ---
        // FIX: Clear list content to prevent duplicate rendering of names
        list.innerHTML = ''; 

        artists.forEach((artist) => {
            const block = document.createElement('div');
            block.className = 'artist-block';
            const name = document.createElement('div');
            name.className = 'artist-name';
            name.textContent = artist.name;
            const thumbs = document.createElement('div');
            thumbs.className = 'artist-thumbnails';
            // CRITICAL FIX: Ensure the thumbnail block has initial size/position set 
            applyRandomThumbnailStyles(thumbs); 
            artist.images.forEach(url => {
                const img = document.createElement('img');
                img.src = url;
                img.loading = 'lazy';
                thumbs.appendChild(img);
            });

            block.appendChild(name);
            block.appendChild(thumbs);
            list.appendChild(block);
        });

        const artistListContainer = document.getElementById('artistToggle');

        // --- COMMON RESET FUNCTION ---
        const resetState = () => {
 
            section.classList.remove('active');
            artistListContainer.classList.remove('has-active-artist');
            section.style.backgroundImage = ""; // Redundant, but harmless cleanup

            if (body) { 
                body.style.backgroundImage = "";
            }

            document.querySelectorAll('.artist-thumbnails').forEach(el => {
                el.classList.remove('active');
                el.querySelectorAll('img').forEach(img => img.style.cssText = '');
            });
            document.querySelectorAll('.artist-name').forEach(el => el.classList.remove('active'));
            
            if (body) {
                body.classList.remove('header-light');
            }
        };

        // --- 5. EVENT HANDLERS ---
        
        // NEW: Use mouseover for activation
        if (list) { 
            list.addEventListener('mouseover', (event) => {
                const hoveredName = event.target.closest('.artist-name');
                if (!hoveredName) return;

                const activeArtistData = artists.find(a => a.name === hoveredName.textContent.trim());
                if (!activeArtistData) return;

                // Only proceed if the current item is NOT already active
                if (hoveredName.classList.contains('active')) return;

                // --- ALWAYS RESET EVERYTHING FIRST (Clears previous state for smooth transition) ---
                resetState();

                // --- ACTIVATE HOVERED ITEM ---
                const parentBlock = hoveredName.closest('.artist-block');
                const thumbs = parentBlock.querySelector('.artist-thumbnails');
                
                thumbs.classList.add('active'); 
                hoveredName.classList.add('active'); 
                section.classList.add('active');

                if (body && activeArtistData.backgroundImage) {
                    body.style.backgroundImage = `url('${activeArtistData.backgroundImage}')`;
                    // The 'header-light' class is what triggers the body background styling in CSS
                    body.classList.add('header-light'); 
                }
                
                artistListContainer.classList.add('has-active-artist'); 
                if (body) {
                    body.classList.add('header-light');
                }
            });
        }

        // CRITICAL FIX: Attach mouseleave to the list container itself for quick deactivation
        if (list) {
            list.addEventListener('mouseleave', () => {
                resetState();
            });
        }
        
    } catch (e) {
        console.error("An error occurred in artist.toggle.js:", e);
    }
});
